import axios from 'axios'

// axios 实例，统一处理响应，后端返回格式为 {code, msg, ...}
// 生产环境通过 .env.production 的 VUE_APP_API_BASE_URL 指定后端真实地址（跨域）
// 本地开发未配置时为空，走 vue.config.js 代理
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: 10000
})

// 响应拦截器：直接返回后端的 data 部分（{code, msg, data...}）
request.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default request
